import React from 'react';
import { Button } from '@zen-common/components-base';

const PaginationButton = (p) => <Button minWidth="120px" width={['100%', null, 'auto']} {...p} />;

export default PaginationButton;
